import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import MaskedIcon from '../../coloredIcons/MaskedIcon/MaskedIcon';
import SpectatorsModal from '../../Modals/SpectatorsModal/SpectatorsModal';
import {selectGameType} from '../../../redux/reducers/sharedStateReducer/selectors';
import {selectLobbyPlayers} from '../../../redux/reducers/privateStateReducer/selectors';
import {GAME_TYPES} from '../../../constants/game';
import {REGISTRY_SINGLETON} from '../../../scenes/Registry';

/**
 * Число зрителей матча в шапке списка игроков: белый глаз и количество, по
 * нажатию — список зрителей (см. SpectatorsModal).
 *
 * Зрители живут в дескрипторе лобби (state.private.lobby.spectators): сервер
 * шлет его и игрокам, и зрителям, и обновляет на каждый их приход и уход.
 * Гостей-зрителей сервер в дескриптор не кладет вовсе — их id позволил бы
 * занять чужой сокет, а ник у всех гостей один.
 *
 * Только сетевой матч: в локальной партии, обучении, кампании и записи матча
 * зрителей не бывает, и нулевой счетчик там был бы шумом
 */
const SpectatorsCount = () => {
  const gameType = useSelector(selectGameType);
  const spectators = useSelector((state) => state.private.lobby.spectators);
  const lobbyPlayers = useSelector(selectLobbyPlayers);
  const [isModalOpen, setModalOpen] = useState(false);

  if (gameType !== GAME_TYPES.ONLINE) {
    return null;
  }

  // Игрок, перезашедший в начатый матч, попадает на сервере и в зрители: join
  // в лобби после старта всегда добавляет зрителя, не глядя, что этот id уже
  // в составе. Сокет потом находит его среди игроков, а запись зрителя так и
  // остается висеть — отсеиваем таких по id из того же дескриптора лобби
  const playerIds = new Set((lobbyPlayers || []).map((player) => player.id));
  const spectatorsList = (spectators || []).filter((spectator) => !playerIds.has(spectator.id));

  const handleClick = () => {
    REGISTRY_SINGLETON.getSoundManager()?.playMenuButtonClick?.();
    setModalOpen(true);
  };

  return (
    <>
      <button
        className={'side-menu-header_spectators'}
        onClick={handleClick}
        title={'Зрители матча'}
      >
        {/* Иконка одноцветная, поэтому красится маской: своего --icon-color у
            панели нет, и без явного цвета глаз вышел бы черным на темном */}
        <MaskedIcon
          className={'side-menu-header_spectators-icon'}
          src={'/img/icons/eye.png'}
          color={'var(--text-primary-color)'}
          alt={'Зрители'}
        />
        <span className={'side-menu-header_spectators-count'}>{spectatorsList.length}</span>
      </button>

      {isModalOpen && (
        <SpectatorsModal spectators={spectatorsList} onClose={() => setModalOpen(false)}/>
      )}
    </>
  );
};

export default SpectatorsCount;
